module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box citic-box"
  }, [_c('the-page-header', {
    attrs: {
      "page-title": "小程序首页管理"
    }
  }), _c('div', {
    staticClass: "transfer-box"
  }, [_c('div', {
    staticClass: "list-box left"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("热门行业")])]), _c('draggable', {
    staticClass: "list",
    attrs: {
      "list": _vm.listCategory,
      "group": "category",
      "ghostClass": "ghost",
      "sort": false
    }
  }, _vm._l((_vm.listCategory), function(item, index) {
    return _c('div', {
      staticClass: "option"
    }, [_c('strong', [_vm._v(_vm._s(item.categoryname))]), _c('i', [_vm._v(_vm._s(item.dpnum))])])
  }), 0)], 1), _c('div', {
    staticClass: "list-box right"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("首页排序管理")])]), _c('draggable', {
    staticClass: "list",
    class: _vm.drag ? 'draging' : '',
    attrs: {
      "list": _vm.listCategoryIndex,
      "animation": 200,
      "group": "category",
      "ghostClass": "ghost"
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "name": !_vm.drag ? 'flip-list' : null
    }
  }, _vm._l((_vm.listCategoryIndex), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "option"
    }, [_c('strong', [_vm._v(_vm._s(item.categoryname))]), _c('i', [_vm._v(_vm._s(item.dpnum))])])
  }), 0)], 1)], 1)]), _c('div', {
    staticClass: "ctrl-box"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleUpdateIndex
    }
  }, [_vm._v("更新首页")])], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-09614484!./~/_vue-loader@9.9.5@vue-loader/lib/template-loader.js?raw&engine=pug!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/mpIndex/home.vue
// module id = 442
// module chunks = 11